import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export default () => {
  return (
    <Tooltip
      overlayInnerStyle={{ width: '400px' }}
      title={
        <p>
          以下几类客户遇到星级和状态修改成：1星--捣乱申请 <br />
          1.空号、停机、老赖、黑户、执行人、逾期时间很长。 <br />
          2.态度不好、骂人、要举报、投诉之类。 <br />
          3.异地且不来上海的。 <br />
        </p>
      }
    >
      <InfoCircleOutlined />
    </Tooltip>
  );
};
